export default {
  one_time: "一次性",
  title: "選擇適合您的方案",
  subtitle: "所有新用戶均可享受 {0} 天試用 — 發現專業功能。",
  free: "免費",
  basic: "基礎版",
  pro: "專業版",
  month: "每月",
  year: "每年",
  freeSubtitle: "適合個人用戶和測試",
  basicSubtitle: "完美適合中小型企業",
  proSubtitle: "完美適合大型企業和專業團隊",
  current: "目前方案",
  current_plan: "目前方案",
  try: "免費試用",
  upgrade: "立即升級",
  contact: "聯絡我們",
  contact_sales: "聯絡銷售",
  calcs: "計算次數",
  reports: "報告",
  calls_per_month: "次呼叫/月",
  keys: "金鑰",
  calculations: "碳排放計算",
  f_reports: "PDF 報告",
  f_factor: "基礎排放係數",
  f_no_api: "無 API 存取權限",
  f_support: "電子郵箱/工單支援",
  priority_support: "優先技術支援",
  b_reports: "Excel 報告",
  b_factor: "自訂排放係數",
  b_custom_logo: "自訂商標",
  b_api_access: "API 存取權限",
  p_dedicated_support: "專屬客戶支援",
  p_custom_solutions: "客製化解決方案",
  p_training: "團隊培訓服務",
  refund: "如果在試用期間不滿意，您可以",
  refund_btn: "申請退款",
  refund_suffix: "。",
  powered_by: "支付服務由以下提供商提供",
  pay_provider: "paddle",
  paymentLegal: {
    title: "付款法律聲明",
    price_currency:
      "價格：價格以歐元顯示，並通過我們授權的合作夥伴 Paddle 安全處理。根據您的所在地區，可能會產生額外稅費。",
    vat_tax:
      "增值稅：商業客戶負責繳納適用的稅務申報。我們目前不直接收取增值稅，但 Paddle 會在結帳時根據需要處理稅務計算。",
    payment_method:
      "付款通過 Paddle 安全處理，支援主流信用卡、PayPal、Apple Pay 和地區性付款方式。不提供信託服務。",
    financial_liability: "我們不提供投資、交易或金融諮詢服務。存取僅限於 SaaS 訂閱。",
    refund_policy: "退款政策：",
    refund_guarantee: "我們為所有通過 Paddle 進行的首次訂閱購買提供 14 天退款保證。",
    refund_request: "退款請求可隨時通過帳單 - 訂單部分提交，或聯絡我們的支援團隊。",
    right_of_withdrawal:
      "存取或使用付費功能 — 包括 CBAM 排放計算、報告生成、API 使用或自動審計計算 — 即表示您承認並同意根據歐盟消費者保護法規，對於完全交付使用的數位服務，您的撤銷權被視為已放棄。",
    subscription_renewals:
      "續訂後 7 天內提交的退款請求符合退款資格。7 天後提交的請求可能符合按未使用帳單期間比例計算的退款資格。當在目前帳單週期內已使用付費功能時，續訂不提供退款。",
    buy_what_you_need: "未使用的點數可隨時全額退款。已使用的點數不予退款。",
    refund_restrictions:
      "如發生以下情況，無法提供退款：已生成 CBAM 報告。已執行碳排放計算或相關審計計算。在帳單期間使用了任何付費 API 端點。懷疑存在欺詐、濫用或服務濫用行為。",
    after_refund_approval:
      "退款批准後：所有付費功能的存取權限將立即撤銷。您的帳戶將降級為免費方案。所有未來的續訂將被取消。剩餘的免費方案配額將根據原始免費分配中未使用的部分恢復，而不是恢復到完整容量。",
  },
  vat_note: "價格不含適用的增值稅。歐盟用戶需繳納當地增值稅。",
  pay_per_use_desc: "按使用付費，無需訂閱",
  pay_per_use_benefits_title: "按使用付費的優勢",
  pay_per_use_benefit1: "無需訂閱",
  pay_per_use_benefit2: "只為使用的部分付費",
  pay_per_use_benefit3: "永久有效",
  buy_credits: "購買點數",
  most_popular: "最受歡迎",
  save_with_annual: "選擇年度方案可節省 {amount}",
  monthly: "月付",
  annually: "年付",
  enterprise: "企業版",
  enterpriseSubtitle: "為專業用戶量身定制的解決方案",
  e_custom_solutions: "客製化解決方案",
  start_trial: "註冊時可享 {0} 天試用",
  all_paid_plans_include_free: "所有付費方案均包含免費方案的所有功能。",
  fq: {
    title: "帳單和訂閱常見問題",
    plans_q: "有哪些訂閱方案可供選擇？",
    plans_a:
      "我們提供免費（每月 100 次計算）、14 天試用（500 次計算）、基礎版（49 歐元/月）、專業版（99 歐元/月）和按使用付費（1.5 歐元/次計算）。詳情請參閱價格頁面。",
    upgrade_q: "我可以升級或降級我的方案嗎？",
    upgrade_a: "可以，在帳戶設定中即可即時升級或降級。變更會立即生效，並按比例調整費用。",
    trial_q: "免費試用如何運作？",
    trial_a:
      "新用戶可獲得 {0} 天試用，享有所有專業功能。除非升級，否則試用期結束後將回到免費方案（{1} 次計算）。",
    autocharge_q: "我的訂閱會自動續訂嗎？",
    autocharge_a: "是的，預設情況下自動續訂已啟用。您可以隨時在帳單設定中停用。",
    payment_methods_q: "支援哪些付款方式？",
    payment_methods_a:
      "付款通過我們官方付款提供商 Paddle 安全處理，支援主流信用卡、PayPal、Apple Pay 和地區性付款方式。增值稅和適用稅費由 Paddle 在結帳時自動計算。",
    invoice_q: "你們提供增值稅合規發票嗎？",
    invoice_a:
      "是的，付款完成後可取得增值稅合規發票。歐盟客戶須提供有效的增值稅識別號碼才能享受免稅優惠。",
    refund_q: "我可以申請退款嗎？",
    refund_a: "退款請求可通過帳戶設定中的訂閱頁面提交。退款資格遵循我們的 14 天退款政策。",
    data_security_q: "我的數據如何受到保護？",
    data_security_a: "我們遵守 GDPR，使用加密傳輸和安全儲存。數據對您的帳戶而言是私有的。",
    cancel_q: "如果我取消會怎樣？",
    cancel_a: "您可以隨時在訂閱設定中取消。存取權限將持續到帳單週期結束，然後回到免費方案。",
  },
};
